/**
 * Profile Settings Page
 */

import { Card, Heading, MetadataField, Stack } from '@cortex/ui';
import { createFileRoute } from '@tanstack/react-router';

import { useAuthContext } from '@/providers/auth-provider';

export const Route = createFileRoute('/_app/settings/profile')({
  component: ProfileSettingsPage,
});

function ProfileSettingsPage() {
  const { user } = useAuthContext();

  return (
    <Stack>
      <Heading level={1} className="mb-6 text-2xl font-semibold">
        Profile Settings
      </Heading>

      <Card className="max-w-2xl p-6">
        <Stack gap="lg">
          <MetadataField label="Email">{user?.email}</MetadataField>

          <MetadataField label="Name">{user?.name ?? 'Not set'}</MetadataField>

          <MetadataField label="Role" valueClassName="capitalize">
            {user?.role ?? 'Member'}
          </MetadataField>

          {user?.organization && (
            <MetadataField label="Organization">
              {user.organization.name}
            </MetadataField>
          )}
        </Stack>
      </Card>
    </Stack>
  );
}
